import { Box, Typography } from "@mui/material";
import { Check } from "@mui/icons-material";
import { ReactNode } from "react";

interface Props {
  checked: boolean;
  onChange: (checked: boolean) => void;
  label: ReactNode;
  /** Bloquea el toggle, para autorizaciones que ya quedaron registradas y no se pueden revertir. */
  disabled?: boolean;
  /**
   * Quita fondo, borde y padding, dejando solo el check y el texto. Es como el
   * diseño usa la fila dentro de una card que ya aporta su propia superficie
   * (ej. el bloque "Autorizaciones requeridas"); apilar dos superficies grises
   * ahí se ve como una card dentro de otra.
   */
  bare?: boolean;
}

/**
 * Replica `.consent-row` + `.check` del diseño: fila clickeable con check
 * cuadrado custom, para autorizaciones/consentimientos legales.
 */
export const ConsentRow = ({ checked, onChange, label, disabled = false, bare = false }: Props) => (
  <Box
    component="button"
    type="button"
    disabled={disabled}
    onClick={() => onChange(!checked)}
    sx={{
      display: "flex",
      alignItems: "flex-start",
      gap: "12px",
      width: "100%",
      textAlign: "left",
      fontFamily: "Outfit",
      cursor: disabled ? "default" : "pointer",
      ...(bare
        ? { bgcolor: "transparent", border: "none", p: 0 }
        : { bgcolor: "#F4F6F9", border: "1px solid #E4E7EC", borderRadius: "10px", p: "14px 16px" }),
    }}
  >
    <Box
      sx={{
        width: 16,
        height: 16,
        mt: "1px",
        flexShrink: 0,
        borderRadius: "5px",
        border: "1.5px solid",
        borderColor: checked ? "primary.main" : "#D6DBE3",
        bgcolor: checked ? "primary.main" : "background.paper",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        transition: "all .12s ease",
      }}
    >
      {checked && <Check sx={{ fontSize: 11, color: "#fff" }} />}
    </Box>
    <Typography sx={{ fontSize: 13, color: "text.secondary", lineHeight: 1.55 }}>{label}</Typography>
  </Box>
);
